<h1>{{'REGISTER.WELCOME_HEADER' | translate}}</h1>
<h2>{{queryParams.userid_hint}}</h2>
<p class="mb30">{{'REGISTER.WELCOME_LABEL' | translate}}</p>
<ng-container *cidContentLoader="pageLoading">
<dynamic-form [fields]=missingFields [options]=dynamicFormOptions [appearance]="'standard'"
  (onSubmit)="_onSubmit($event)" (onReset)="_onReset($event)"></dynamic-form>

<div class="mat-error">{{errorMessage | translate}} </div>

<div class="section btn-group">
  <a (click)="_onReset(1)"><label for="cidaasCancelBtn">{{'BACK' | translate}}</label></a>
  <app-button [btnOption]="buttonOptions.submit">
  </app-button>
</div>
</ng-container>
